import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "views/LoginForm/loginSlice";
import appReducer from "common/appSlice";

export default configureStore({
  reducer: {
    login: loginReducer,
    app: appReducer,
  },
});
